import React from "react";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";

const multiple = nota.global.multiple;

const ButtonStyled = styled.div`
  .cta {
    max-width: ${multiple * 25 + "px"}; /*200px*/
    min-width: ${multiple * 15 + "px"}; /*120px*/
    margin: ${multiple * 2 + "px"}; /*16px*/
    padding: 8px 12px;
    line-height: 15px;
    background-color: ${(props) => (props.secondary ? nota.color.neutral.white : props.warning ? nota.color.main.mTwo : nota.color.main.default)};
    text-align: center;
    border: ${(props) => (props.secondary ? `2px solid ${nota.color.main.default}` : "0")};
    cursor: pointer;
    text-transform: uppercase;
    font-size: ${(props) => (props.secondary ? "13px" : "15px")};
    letter-spacing: 0.5px;
    color: ${(props) => (props.secondary ? nota.color.main.default : nota.color.neutral.white)};
    font-weight: bold;
    user-select: none;
    font-family: ${nota.font};
    &:hover {
      opacity: 0.7;
      transition: all 0.3s ease-in-out;
    }
    &:focus {
      outline: 0;
    }
  }
  .disable {
    background-color: ${(props) => (props.secondary ? nota.color.neutral.white : nota.color.neutral.NeuTwo)};
    border: ${(props) => (props.secondary ? `2px solid ${nota.color.neutral.NeuTwo}` : "0")};
    color: ${(props) => (props.secondary ? nota.color.neutral.NeuTwo : nota.color.neutral.white)};
    pointer-events: none;
    cursor: default;
    &:hover {
      opacity: 1;
      transition: all 0.3s ease-in-out;
    }
  }
`;

const ButtonSimpleStyled = styled.div`
  .cta {
    max-width: ${multiple * 25 + "px"}; /*200px*/
    min-width: ${multiple * 15 + "px"}; /*120px*/
    text-align: center;
    cursor: pointer;
    font-size: 13px;
    letter-spacing: 0.5px;
    border: 0;
    background-color: transparent;
    color: ${nota.color.neutral.NeuOne};
    user-select: none;
    font-family: ${nota.font};
    &:hover {
      color: ${nota.color.main.default};
      transition: all 0.3s ease-in-out;
    }
    &:focus {
      outline: 0;
    }
  }
  .disable {
    border: 0;
    background-color: transparent;
    color: ${nota.color.neutral.NeuTwo};
    pointer-events: none;
    cursor: default;
    &:hover {
      color: ${nota.color.neutral.NeuTwo};
      opacity: 1;
      transition: all 0.3s ease-in-out;
    }
  }
`;

const Button = (props) => {
  if (props.simple) {
    return (
      <ButtonSimpleStyled className="simpleButtonWrapper">
        <button className={props.disable ? "cta disable" : "cta"} type={props.type} onClick={() => props.clickAction(props.id)}>
          {props.label}
        </button>
      </ButtonSimpleStyled>
    );
  } else {
    return (
      <ButtonStyled className="buttonWrapper" secondary={props.secondary} disable={props.disable} warning={props.warning}>
        <button className={props.disable ? "cta disable" : "cta"} type={props.type} onClick={() => props.clickAction(props.id)}>
          {props.label}
        </button>
      </ButtonStyled>
    );
  }
};

// Set default props
Button.defaultProps = {
  id: 0,
  label: "",
  type: "submit",
  secondary: false,
  disable: false,
  warning: false,
  simple: false,
  clickAction: () => null,
};

export default Button;

/*
Doc
import Button from './Nano/Buttons/Button.js';

Primary Button
<Button id={1} label={'login'} clickAction={(id) => console.log(id)} />
<Button id={2} label={'login'} disable />

Warning Button
<Button  label={'continue'} warning />

Secondary Button
<Button id={3} label={'free trial'} secondary />
<Button id={4} label={'free trial'} secondary disable />

Simple Button
<Button label={'CANCEL'} simple />
<Button label={'CANCEL'} simple disable/>
*/
